import Proxy from './Proxy';

class GroupUsersProxy extends Proxy {
  /**
   * The constructor for the CareplanProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/GroupUsers', parameters);
  }

  getGroupUserList(data) {
    // eslint-disable-next-line 
    console.log('GroupPatientsProxy -> getGroupUserList in');
    const url = `${this.endpoint}/${data.groupId}/users/${data.filterType}?usertype=${data.userType}`;
    const postData = {
      searchValue: '',
      limit: data.limit,
      skip: data.skip,
    };
    return this.submit('post', url, postData);
  }

  assignUnassignMany(data) {
    const url = `${this.endpoint}/${data.type == 'assign' ? 'assignMany' : 'unassignmany'}`;
    return this.submit('post', url, {
      group_id: data.groupId,
      users: data.users
    });
  }
}

export default GroupUsersProxy;
